import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountingFrontDeskList from './components/AccountingFrontDeskList'


const { Cell } = ResponsiveGrid;

const AccountingFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="會計前台"
        breadcrumbs={[
          {
            name: '會計系統',
          },
          {
            name: '會計前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountingFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default AccountingFrontDesk;
